import axiosHttp from "axios";
import { Notification } from "element-ui";
import router from '../router'
import store from '../stores/index.js'

let base = store.state.base;
axiosHttp.defaults.withCredentials = true;
// POST 方法封装  (参数处理)
export const postFormRequest = (url, params, callback, errCallback) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

export const postRequest = (url, params, callback, errCallback, successNotify) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  }).then(res => {
    if(checkCode(res, errCallback, successNotify)) {
      callback(res.data);
    }
  });
}

// POST 方法封装  (文件上传)
export const uploadFileRequest = (url, params, callback, errCallback) => {
  axiosHttp({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

//  GET 方法封装
export const getRequest = (url, callback, errCallback) => {
  axiosHttp({
    method: 'get',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback, true)) {
      callback(res.data);
    }
  });
}

export const downloadFile = (url, callback, errCallback) => {
  axiosHttp({
    method: 'get',
    url: `${url}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'audio/mpeg;charset=UTF-8'
    }
  }).then(res => {
    callback(res.data);
  });
}


//  PUT 方法封装
export const putFormRequest = (url, params, callback, errCallback) => {
  return axiosHttp({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}

export const putRequest = (url, params, callback, errCallback, successNotify) => {
  axiosHttp({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback, successNotify)) {
      callback(res.data);
    }
  });
}

//  DELETE 方法封装
export const deleteRequest = (url, callback, errCallback) => {
  axiosHttp({
    method: 'delete',
    url: `${base}${url}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then(res => {
    if(checkCode(res, errCallback)) {
      callback(res.data);
    }
  });
}


//  REQUEST 请求异常拦截
axiosHttp.interceptors.request.use(config=> {
  config.headers.Auth = window.localStorage.getItem('USER_TOKEN');
  return config;
}, err=> {
  //==================  错误处理  ====================
  //Message.error({message: '请求超时!'});
  Notification.error({
    message: '408 Request Timeout',
    offset: 50
  })
  return Promise.reject(err);
})

//请求返回拦截
axiosHttp.interceptors.response.use(response => {
    return Promise.resolve(response);
  },
  error => {
    checkStatus(error)
    return Promise.reject(error)
  }
)

// http状态码错误处理
const checkStatus = (err) => {
  console.log(err);
  if (err && err.response) {
    switch (err.response.status) {
      case 400: err.message = '400 Bad Request'; break;
      case 401: err.message = '401 Unauthorized'; break;
      case 403: err.message = '403 Forbidden'; break;
      case 404: err.message = '404 Not Found'; break;
      case 408: err.message = '408 Request Timeout'; break;
      case 500: err.message = '500 Internal Server Error'; break;
      case 501: err.message = '501 Not Implemented'; break;
      case 502: err.message = '502 Bad Gateway'; break;
      case 503: err.message = '503 Service Unavailable'; break;
      case 504: err.message = '504 Gateway Timeout'; break;
      case 505: err.message = '505 HTTP Version Not Supported'; break;
      default: err.message = `Error (${err.response.status})。`;
    }
  } else {
    err.message = '连接服务器失败。'
  }
  //Message.error( {message: err.message } )
  Notification.error({
    message: err.message,
    offset: 50
  })
}

// 后台自定义 code错误处理
const checkCode = (res, errCallback, successNotify) => {
  if(res){
    if(res.data.code === 200 || res.data.errorCode === 0 || res.data.errorCode === 103){       //code为0成功 103修改密码成功，重新登录
      if(!successNotify) {
        Notification.success({
          message: (res.data.message ? res.data.message : res.data.description),
          offset: 50
        })
      }
      return true
    } else if(res.data.code === 10003 || res.data.code === 10004 || res.data.code === 102) {
      Notification.error({
        message: (res.data.message ? res.data.message : res.data.description),
        offset: 50
      })
      //请求过期等，需要跳转到登录页
      window.localStorage.setItem("Y_REMENBERME", false);
      router.push("/").then(r => {return true});
      return false;
    } else {
      if(errCallback) {
        errCallback(res.data);
        return false;
      } else {
        Notification.error({
          message: (res.data.message ? res.data.message : res.data.description),
          offset: 50
        })
        return false;
      }
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/http.js